export const ANIMATE = 'PERSISTENT_BAR:ANIMATE';
export const READY = 'PERSISTENT_BAR:READY';
export const UPDATE = 'PERSISTENT_BAR:UPDATE';
export const DESTROY = 'PERSISTENT_BAR:DESTROY';
export const INTERSECTION_CHANGE = 'PERSISTENT_BAR:INTERSECTION_OBSERVER:CHANGE';
